module.exports = __webpack_public_path__ + "logo2.png";